export default __webpack_public_path__ + "static/media/cake3.46253025.jpg";